<div class="w-full h-full flex flex-col gap-2 justify-center items-center text-xl text-center opacity-60 p-10">
  <ng-content></ng-content>
</div>
